// PhoneInput.js
import { useRef } from "react";

export default function PhoneInput({ value, onChange }) {
  const inputRef = useRef(null);

  const handleChange = (e) => {
    const digits = e.target.value.replace(/\D/g, "");
    if (digits.length <= 10) {
      onChange(digits); // send value back to parent
    }
  };

  const formatPhone = (val) => {
    const d = val.split("");
    return [
      d.slice(0, 3).join(""),
      d.slice(3, 6).join(""),
      d.slice(6, 10).join("")
    ];
  };

  const [part1, part2, part3] = formatPhone(value);

  return (
    <div
      className="flex mt-5 w-full max-w-sm justify-center gap-2 cursor-text"
      onClick={() => inputRef.current?.focus()}
    >
      {/* make as single input */}
      {/* <input
        ref={inputRef}
        type="tel"
        value={value}
        onChange={handleChange}
        maxLength={10}
        className="absolute opacity-0 pointer-events-none"
      /> */}
      <input
        ref={inputRef}
        type="tel"
        value={value}
        onChange={handleChange}
        maxLength={10}
        placeholder="(555) 555-5555"
        className="w-full md:text-[30px] text-[20px] px-4 py-3 border rounded-xl focus:outline-none"
      />
      {/* input boxes */}
      {/* <div className="flex gap-2 px-4  border rounded-xl w-full max-w-sm">
         <span className="text-2xl font-medium text-gray-400 my-5">(</span> 
        {Array.from({ length: 3 }).map((_, i) => (
          <div key={i} className="w-6 h-16 flex items-center justify-center border-b-2 border-gray-400 text-2xl font-medium">
           <span className="pt-3 text-gray-400">{part1[i] || "5"}</span>
          </div>
        ))}
         <span className="text-2xl font-medium text-gray-400 my-5">) </span> 
        {Array.from({ length: 3 }).map((_, i) => (
          <div key={i} className="w-6 h-16 flex items-center justify-center border-b-2 border-gray-400 text-2xl font-medium">
           <span className="pt-3 text-gray-400">{part2[i] || "5"}</span> 
          </div>
        ))}
         <span className="text-2xl font-medium text-gray-400 my-5">-</span> 
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="w-6 h-16 flex items-center justify-center border-b-2 border-gray-400 text-2xl font-medium">
            <span className="pt-3 text-gray-400">{part3[i] || "5"}</span>
          </div>
          
        ))}
       
      </div> */}
    </div>
  );
}
